import ApiLogin from '../services/ApiLogin'

export default (expression) => {
  // const url = 'https://cors-anywhere.herokuapp.com/https://cronexpressiondescriptor.azurewebsites.net/api/descriptor/?expression=' + expression + '&locale=pt-BR'
  const url = 'cronExpressionDescriptor?expression=' + decodeURIComponent(expression)
  return ApiLogin().get(url)
}
